import React from 'react';
import { Redirect } from 'react-router-dom';

const AuthContext = React.createContext(null);

const withAuthentication = Component => props => (
    <AuthContext.Consumer>
        {user => 
            user
                ? <Component {...props} user={user} />
                : <Redirect to='/login' /> 
        }
    </AuthContext.Consumer>
);

const withNoAuthentication = Component => props => (
    <AuthContext.Consumer>
        {user => 
            user
                ? <Redirect to='/' />
                : <Component {...props} />
        }
    </AuthContext.Consumer>
);

export { AuthContext, withAuthentication, withNoAuthentication };